<template>
    <div id="tab">
        <el-main v-loading="loading">
            <el-form :inline="true" class="query_form" size="small">
                <el-form-item label="当期范围">
                    <date-picker class="query_form_item" style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" @change="dataChange">
                    </date-picker>
                </el-form-item>
            </el-form>
            <div class="chart-box">
                <div class="box">
                    <p>商品铺市率</p>
                    <div id="leftChart"></div>
                </div>
                <div class="box">
                    <p>门店覆盖率</p>
                    <div id="rightChart"></div>
                </div>
            </div>
            <div class="item-box">
                <div class="item">
                    <p>期内销售商品共{{params.saleItemNumber}}种<br>占比{{params.saleProportion}}%</p>
                    <p class="p1" @click="toLink('B', 1)">点击查看畅销商品</p>
                </div>
                <div class="item">
                    <p>期内未销售商品共{{params.unSaleItemNumber}}种<br>占比{{params.unSaleProportion}}%</p>
                    <p class="p1" @click="toLink('C', 1)">点击查看滞销商品</p>
                </div>
                <div class="item">
                    <p style="line-height: 40px;">期内退货商品共{{params.returnItemNumber}}种</p>
                    <p class="p1" @click="toLink('D', 1)">点击查看退货商品</p>
                </div>
                <div class="item">
                    <p>期内达成客户{{params.reachCustomer}}家<br>占比{{params.reachCustomerProportion}}%</p>
                    <p class="p1" @click="toLink('B', 2)">点击查看活跃客户</p>
                </div>
                <div class="item">
                    <p>期内未达成客户{{params.unReachCustomer}}家<br>占比{{params.unReachCustomerProportion}}%</p>
                    <p class="p1" @click="toLink('C', 2)">点击查看未采购客户</p>
                </div>
            </div>
        </el-main>
    </div>
</template>
<script>
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getAddDate, getNowFormatDate, toRawType, toFixedRe } from '@/assets/js/common.js'
export default {
    name: 'MarketIndex',
    components: {
        datePicker
    },
    data() {
        let beginDate = getAddDate(-3)
        let endDate = getNowFormatDate()
        return {
            leftChart: {
                tooltip: {
                    trigger: 'item',
                    formatter(params) {
                        let circle = '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:' + params.color + ';"></span>';
                        return circle + params.data.name + '共' + params.data.value + '种，<br /><span style="margin-left: 15px;">占比' + params.data.pro + '%</span>'
                    }
                },
                color: ['#EE6666', '#91CC75'],
                legend: {
                    bottom: '0%',
                    left: 'center'
                },
                title: {
                    // 设置饼图标题，位置设为顶部居中
                    text: "商品铺市率",
                    top: "center",
                    left: "center"
                },
                series: [{
                    name: '商品铺市率',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                }]
            },
            rightChart: {
                tooltip: {
                    trigger: 'item',
                    formatter(params) {
                        let circle = '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:' + params.color + ';"></span>';
                        return circle + params.data.name + params.data.value + '家，<br /><span style="margin-left: 15px;">占比' + params.data.pro + '%</span>'
                    }
                },
                color: ['#FAC858', '#5470C6'],
                legend: {
                    bottom: '0%',
                    left: 'center'
                },
                title: {
                    // 设置饼图标题，位置设为顶部居中
                    text: "门店覆盖率",
                    top: "center",
                    left: "center"
                },
                series: [{
                    name: '门店覆盖率',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                }]
            },
            queryForm: {
                billDate: { submitName: 'billDate', selected: [beginDate, endDate] },
            },
            pickerOptions: pickerOptions,
            params: {},
            loading: false
        }
    },
    computed: {
        queryItem() {
            let tempItem = {}
            Object.values(this.queryForm).forEach(item => {
                if (item.submitName == 'billDate') {
                    console.log(item.selected)
                    tempItem['beginDate'] = item.selected && item.selected.length > 0 ? item.selected[0] : ''
                    tempItem['endDate'] = item.selected && item.selected.length > 0 ? item.selected[1] : ''
                }
            })
            return tempItem
        },
    },
    created() {},
    mounted() {
        this.initEcharts()
    },
    methods: {
        async initEcharts() {
            this.loading = true
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/ShopMarket/selectHomeList.html', this.queryItem)
            this.loading = false
            if (res.code != '0') return this.$message.error(res.message)
            console.log(res.data)
            this.params = { ...res.data }
            this.leftChart.series[0].data = [
                { value: res.data.unSaleItemNumber, name: '期内未铺市商品', pro: res.data.unSaleProportion },
                { value: res.data.saleItemNumber, name: '期内铺市商品', pro: res.data.saleProportion }
            ]
            this.rightChart.series[0].data = [
                { value: res.data.unReachCustomer, name: '期内未销售门店', pro: res.data.unReachCustomerProportion },
                { value: res.data.reachCustomer, name: '期内销售门店', pro: res.data.reachCustomerProportion }
            ]
            console.log(this.leftChart)
            const chart1 = this.$echarts.init(document.getElementById("leftChart")); // 图标初始化
            const chart2 = this.$echarts.init(document.getElementById("rightChart")); // 图标初始化
            chart1.setOption(this.leftChart); // 渲染页面
            chart2.setOption(this.rightChart); // 渲染页面
            // //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                chart1.resize();
                chart2.resize();
            });
        },
        toLink(tag, type) {
            let url = '',
                title = '',
                beginDate = this.queryItem.beginDate,
                endDate = this.queryItem.endDate
            if (type == 1) {
                url = `/templates/vue-account/dist/index.htm#/ItemMarket?selectType=${ tag }&beginDate=${ beginDate }&endDate=${ endDate }`
                title = '商品铺市'
            } else {
                url = `/templates/vue-account/dist/index.htm#/CustomerCover?customerIDType=${ tag }&beginDate=${ beginDate }&endDate=${ endDate }`
                title = '门店覆盖'
            }
            console.log(url)
            let width = window.top.document.browser.availiframeWidth.value,
                height = window.top.document.browser.availiframeHeight.value
            top.addPanel(title, url, width, height, true)
        },
        dataChange(val) {
            console.log(this.queryItem)
            this.initEcharts()
        }
    }
}
</script>
<style lang="less" scoped>
.el-main {
    padding: 0;
    height: 100%;
    border: 1px solid #ccc;

    .query_form {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-top: 12px;

        .el-form-item {
            margin-bottom: 12px;
        }
    }

    .chart-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        .box {
            display: flex;
            flex-direction: column;
            align-items: center;

            p {
                font-size: 28px;
                color: #333;
                margin-top: 10px;
            }
        }

        #leftChart,
        #rightChart {
            width: 400px;
            height: 300px;
            // background-color: #F3F3F3;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: -30px 20px 0;
        }
    }

    .item-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        margin-top: 30px;

        .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: 150px;
            border: 1px solid #ccc;

            p {
                line-height: 20px;
                font-size: 13px;
                text-align: center;
                padding: 6px;
                width: 100%;

                &.p1 {
                    border-top: 1px dashed #ccc;
                    font-weight: bolder;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>